module.exports = __webpack_public_path__ + "img/window.b44465c6.svg";